<div class="flex flex-col flex-auto w-full min-h-screen"><router-outlet></router-outlet></div>
